"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeIdString = makeIdString;
exports.textfieldPropTypes = exports.fieldPropTypes = exports.wrapIfHorizontal = exports.makeIdFromName = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _fieldsize = require("./fieldsize");

var _field = _interopRequireDefault(require("./field.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function makeIdString() {
  return Math.random().toString(36).slice(2);
}

var makeIdFromName = function makeIdFromName(name) {
  return name.replace(/[^A-Za-z0-9]/g, '-');
};

exports.makeIdFromName = makeIdFromName;

var wrapIfHorizontal = function wrapIfHorizontal(opts, children) {
  return opts.isHorizontal ? _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_field["default"]["horizontal".concat(opts.type, "Wrapper")], opts.classNames["horizontal".concat(opts.type, "Wrapper")])
  }, children) : children;
};

exports.wrapIfHorizontal = wrapIfHorizontal;

var fieldPropTypes = _objectSpread({
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  type: _propTypes["default"].string
}, _fieldsize.fieldSizePropTypes, {
  errorMessage: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  subLabel: _propTypes["default"].string,
  classNames: _propTypes["default"].object,
  label: _propTypes["default"].node,
  id: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  tooltip: _propTypes["default"].node,
  isHorizontal: _propTypes["default"].bool
});

exports.fieldPropTypes = fieldPropTypes;

var textfieldPropTypes = _objectSpread({}, fieldPropTypes, {
  maxLength: _propTypes["default"].number,
  pattern: _propTypes["default"].string,
  autoComplete: _propTypes["default"].string,
  autoCorrect: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  innerRef: _propTypes["default"].func,
  showCharacterCount: _propTypes["default"].bool,
  suggestedLength: _propTypes["default"].number,
  step: _propTypes["default"].number
});

exports.textfieldPropTypes = textfieldPropTypes;